import { RESET_STATE } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import {
    ALL_PROPOSED_REGULATION_RECEIVED,
    ALL_RESTRICTIONS_RECEIVED,
    CHECK_REGULATION_HAS_PROPOSED_REGULATION,
    COPY_REGULATION_TO_PROPOSED,
    DELETE_PROPOSED_REGULATION,
    DELETE_PROPOSED_RESTRICTION,
    GET_ALL_RESTRICTIONS,
    GET_PROPOSED_REGULATION,
    GET_PROPOSED_RESTRICTION,
    GET_REGULATION_LINKS,
    GET_REGULATION_SECTION,
    PROPOSED_REGULATION_DELETED,
    PROPOSED_REGULATION_RECEIVED,
    PROPOSED_REGULATION_UPDATED,
    PROPOSED_RESTRICTION_DELETED,
    PROPOSED_RESTRICTION_RECEIVED,
    PROPOSED_RESTRICTION_UPDATED,
    RECEIVED_CHECK_REGULATION_HAS_PROPOSED_REGULATION,
    REGULATION_AND_RATES_FOR_SCENARIO_RECEIVED,
    REGULATION_LINKS_RECEIVED,
    REGULATION_SECTION_RECEIVED,
    REGULATION_TO_PROPOSED_POSTED,
    RegulationState,
    RegulationTypes,
    TOGGLE_CREATE_OR_EDIT_ACTION_PERFORMED,
    TOGGLE_EDIT_OPTIONS_PANEL,
    TOGGLE_EDIT_REGULATION_PANEL,
    UPDATE_FILTERED_LINKS,
    UPDATE_FILTERED_PROPOSED_LINKS,
    UPDATE_PROPOSED_REGUATION,
    UPDATE_PROPOSED_RESTRICTION
} from "../../actions/regulation/types";
import { defaultGetResponse } from "../../interfaces/ActionReducer/GetMethod/GetResponse";

const initialState: RegulationState = {
    requestOrigin: null,
    filteredProposedLinks: {
        disabled: {},
        notDisabled: {}
    },
    filteredLinks: {
        disabled: {},
        notDisabled: {}
    },
    allRestrictions: defaultGetResponse,
    allRegulationsAndRatesForScenario: {},
    isAllRestrictionsReceived: false,
    isCopyRegulationToProposedPosted: false,
    isEditOptionsPanelOpen: false,
    isEditRegulationPanelOpen: false,
    isProposedRegulationDeleted: false,
    isProposedRegulationReceived: false,
    isProposedRegulationUpdated: false,
    isProposedRestrictionDeleted: false,
    isProposedRestrictionReceived: false,
    isProposedRestrictionUpdated: false,
    isRegulationHasProposedRegulationCheckInProgress: false,
    isRegulationLinksReceived: false,
    isRegulationSectionReceived: false,
    proposedRegulationBody: {},
    proposedRegulationDeleted: 0,
    proposedRegulationReceived: {},
    allProposedRegulationReceived: {},
    proposedRegulationUpdated: {},
    proposedRestrictionBody: {},
    proposedRestrictionDeleted: 0,
    proposedRestrictionReceived: defaultGetResponse,
    proposedRestrictionUpdated: {},
    regulationId: 0,
    regulationLinksReceived: defaultGetResponse,
    regulationSection: {},
    regulationToProposedPosted: { proposed_regulation_id: 0 },
    toggleCreateorEditActionPerformed: false
};

const regulation = (state = initialState, action: RegulationTypes): RegulationState => {
    switch (action.type) {
        case UPDATE_FILTERED_LINKS: {
            return {
                ...state,
                filteredLinks: action.payload.filteredLinks
            };
        }
        case CHECK_REGULATION_HAS_PROPOSED_REGULATION: {
            return {
                ...state,
                isRegulationHasProposedRegulationCheckInProgress: true
            };
        }
        case RECEIVED_CHECK_REGULATION_HAS_PROPOSED_REGULATION: {
            return {
                ...state,
                isRegulationHasProposedRegulationCheckInProgress: false
            };
        }
        case UPDATE_FILTERED_PROPOSED_LINKS: {
            return {
                ...state,
                filteredProposedLinks: action.payload.filteredProposedLinks
            };
        }
        case GET_REGULATION_SECTION: {
            return {
                ...state,
                isRegulationSectionReceived: false
            };
        }
        case REGULATION_SECTION_RECEIVED: {
            return {
                ...state,
                isRegulationSectionReceived: true,
                regulationSection: action.payload.regulationSection
            };
        }
        case REGULATION_AND_RATES_FOR_SCENARIO_RECEIVED: {
            return {
                ...state,
                allRegulationsAndRatesForScenario: action.payload.regulationsAndRates
            };
        }
        case TOGGLE_EDIT_REGULATION_PANEL: {
            return {
                ...state,
                regulationId: action.payload.regulationId,
                isEditRegulationPanelOpen: action.payload.isEditRegulationPanelOpen
            };
        }
        case TOGGLE_EDIT_OPTIONS_PANEL: {
            return {
                ...state,
                isEditOptionsPanelOpen: action.payload.isEditOptionsPanelOpen
            };
        }
        case GET_ALL_RESTRICTIONS: {
            return {
                ...state,
                isAllRestrictionsReceived: false
            };
        }
        case ALL_RESTRICTIONS_RECEIVED: {
            return {
                ...state,
                isAllRestrictionsReceived: true,
                allRestrictions: action.payload.allRestrictions
            };
        }
        case COPY_REGULATION_TO_PROPOSED: {
            return {
                ...state,
                regulationId: action.payload.regulationId,
                isCopyRegulationToProposedPosted: false
            };
        }
        case REGULATION_TO_PROPOSED_POSTED: {
            return {
                ...state,
                isCopyRegulationToProposedPosted: true,
                regulationToProposedPosted: action.payload.regulationToProposedPosted
            };
        }

        // Proposed Regulation

        case GET_PROPOSED_REGULATION: {
            return {
                ...state,
                isProposedRegulationReceived: false
            };
        }

        case PROPOSED_REGULATION_RECEIVED: {
            return {
                ...state,
                isProposedRegulationReceived: true,
                proposedRegulationReceived: action.payload.proposedRegulationReceived
            };
        }
        case ALL_PROPOSED_REGULATION_RECEIVED: {
            return {
                ...state,
                allProposedRegulationReceived: action.payload.allProposedRegulationReceived,
                requestOrigin: action.payload.requestOrigin
            };
        }
        case UPDATE_PROPOSED_REGUATION: {
            return {
                ...state,
                isProposedRegulationUpdated: false
            };
        }
        case PROPOSED_REGULATION_UPDATED: {
            return {
                ...state,
                isProposedRegulationUpdated: true,
                proposedRegulationUpdated: action.payload.proposedRegulationUpdated
            };
        }

        case DELETE_PROPOSED_REGULATION: {
            return {
                ...state,
                isProposedRegulationDeleted: false
            };
        }
        case PROPOSED_REGULATION_DELETED: {
            return {
                ...state,
                isProposedRegulationDeleted: true,
                proposedRestrictionDeleted: action.payload.proposedRegulationDeleted
            };
        }

        case TOGGLE_CREATE_OR_EDIT_ACTION_PERFORMED: {
            return {
                ...state,
                toggleCreateorEditActionPerformed: !state.toggleCreateorEditActionPerformed
            };
        }

        // Proposed Restriction

        case GET_PROPOSED_RESTRICTION: {
            return {
                ...state,
                isProposedRestrictionReceived: false
            };
        }
        case PROPOSED_RESTRICTION_RECEIVED: {
            return {
                ...state,
                isProposedRestrictionReceived: true,
                proposedRestrictionReceived: action.payload.proposedRestrictionReceived
            };
        }
        case UPDATE_PROPOSED_RESTRICTION: {
            return {
                ...state,
                isProposedRestrictionUpdated: false,
                proposedRestrictionBody: action.payload.proposedRestrictionBody
            };
        }
        case PROPOSED_RESTRICTION_UPDATED: {
            return {
                ...state,
                isProposedRestrictionUpdated: true,
                proposedRestrictionUpdated: action.payload.proposedRestrictionUpdated
            };
        }

        case DELETE_PROPOSED_RESTRICTION: {
            return {
                ...state,
                isProposedRestrictionDeleted: false
            };
        }
        case PROPOSED_RESTRICTION_DELETED: {
            return {
                ...state,
                isProposedRestrictionDeleted: true,
                proposedRestrictionDeleted: action.payload.proposedRestrictionDeleted
            };
        }

        // Regulation Links

        case GET_REGULATION_LINKS: {
            return {
                ...state,
                isRegulationLinksReceived: false
            };
        }

        case REGULATION_LINKS_RECEIVED: {
            return {
                ...state,
                isRegulationLinksReceived: true,
                regulationLinksReceived: action.payload.regulationLinksReceived
            };
        }

        case RESET_STATE: {
            return {
                ...initialState
            };
        }

        default: {
            return {
                ...state
            };
        }
    }
};

export default regulation;
